import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="aufgabe"
export default class extends Controller {
	static targets = ["hiddenPrioField", "archivDiv", "kommentarDiv", "teilaufgabenDiv"]
	connect() {}

	// #####################################################################
	// Setzt den Prio-Value ins Hidden-Field und faerbt das Faehnchen ein
	// #####################################################################
	setzePrioValue({ currentTarget }) {
		const svg = currentTarget.querySelector("svg")
		svg.classList.toggle("!fill-farbe-error")
		this.hiddenPrioFieldTarget.value ^= 1
	}

	// #####################################################################
	// Blendet das Archiv ein und aus
	// #####################################################################
	toggleArchiv({ currentTarget }) {
		if (currentTarget.hasAttribute("data-ui")) {
			currentTarget.removeAttribute("data-ui")
		} else {
			currentTarget.dataset.ui = "aktiv"
		}
		this.archivDivTarget.classList.toggle("hidden")
	}

	// #####################################################################
	// Blendet die Aufgaben-Information ein und aus
	// #####################################################################
	toggleInformation({ currentTarget }) {
		currentTarget.classList.toggle("truncate")
	}

	// #####################################################################
	// Blendet die Kommentare ein und aus
	// #####################################################################
	toggleKommentare({ currentTarget }) {
		if (currentTarget.dataset.ui == "aktiv") {
			currentTarget.dataset.ui == ""
		} else {
			currentTarget.dataset.ui == "aktiv"
		}
		this.kommentarDivTarget.classList.toggle("hidden")
		this.kommentarDivTarget.classList.add("uk-animation-slide-top-small")
		this.teilaufgabenDivTarget.classList.toggle("hidden")
		this.teilaufgabenDivTarget.classList.add("uk-animation-slide-top-small")
	}
}
